export const defaultDuration = window.__cypressToastDuration || 4000;
export const defaultErrorDuration = window.__cypressToastDuration || 6000;
export const defaultErrorExtendedDuration = window.__cypressToastDuration || 8000;
export const defaultSuccessDuration = window.__cypressToastDuration || 2000;
